import { render } from "./WNvirtualCommerce.vue?vue&type=template&id=3f8c8adb&scoped=true"
import script from "./WNvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./WNvirtualCommerce.vue?vue&type=script&lang=js"

import "./WNvirtualCommerce.vue?vue&type=style&index=0&id=3f8c8adb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f8c8adb"

export default script